
import { ExamResult, ExamType } from '../db/types';
import { ExamStats } from './types';
import { getStudentExams } from './examCrudService';
import { toast } from 'sonner';

export async function getExamStatistics(studentId: number | string): Promise<ExamStats> {
  try {
    const exams = await getStudentExams(studentId);
    
    if (!exams.length) {
      return {
        averageScore: 0,
        highestScore: 0,
        lowestScore: 0,
        totalExams: 0,
        scoresByType: {
          monthly: { count: 0, average: 0 },
          annual: { count: 0, average: 0 },
          test: { count: 0, average: 0 },
          quiz: { count: 0, average: 0 },
          other: { count: 0, average: 0 }
        }
      };
    }
    
    // Calculate percentage scores
    const percentages = exams.map(exam => (exam.obtainedScore / exam.maxScore) * 100);
    
    // Calculate overall statistics
    const averageScore = percentages.reduce((sum, score) => sum + score, 0) / percentages.length;
    const highestScore = Math.max(...percentages);
    const lowestScore = Math.min(...percentages);
    
    // Initialize statistics by exam type
    const scoresByType: Record<ExamType, { count: number; average: number }> = {
      monthly: { count: 0, average: 0 },
      annual: { count: 0, average: 0 },
      test: { count: 0, average: 0 },
      quiz: { count: 0, average: 0 },
      other: { count: 0, average: 0 }
    };
    
    // Group exams by type
    exams.forEach(exam => {
      const type = exam.examType;
      const percentage = (exam.obtainedScore / exam.maxScore) * 100;
      
      scoresByType[type].count += 1;
      scoresByType[type].average = 
        (scoresByType[type].average * (scoresByType[type].count - 1) + percentage) / 
        scoresByType[type].count;
    });
    
    return {
      averageScore,
      highestScore,
      lowestScore,
      totalExams: exams.length,
      scoresByType
    };
  } catch (error) {
    console.error('Error calculating exam statistics:', error);
    toast.error('Failed to calculate exam statistics');
    
    return {
      averageScore: 0,
      highestScore: 0,
      lowestScore: 0,
      totalExams: 0,
      scoresByType: {
        monthly: { count: 0, average: 0 },
        annual: { count: 0, average: 0 },
        test: { count: 0, average: 0 },
        quiz: { count: 0, average: 0 },
        other: { count: 0, average: 0 }
      }
    };
  }
}
